import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { BookOpen, Palette, ShoppingCart, Menu, X } from "lucide-react";

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { totalCartCount, setIsCartOpen } = useCart();
  const navigate = useNavigate();

  const handleBooksClick = () => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById('books')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById('books')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleAboutClick = () => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleHomeClick = () => {
    if (window.location.pathname !== '/') {
      navigate('/');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-emerald-900 border-b border-emerald-800 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <button onClick={handleHomeClick} className="flex items-center gap-2" data-testid="nav-logo">
            <BookOpen className="h-8 w-8 text-amber-400" style={{ filter: 'drop-shadow(0 0 2px rgba(251, 191, 36, 0.5))' }} />
            <span className="font-serif font-bold text-xl text-amber-400" style={{ textShadow: '0 0 4px rgba(251, 191, 36, 0.4)' }}>Cornerstone Ink</span>
          </button>
          
          <div className="hidden md:flex items-center gap-6">
            <button 
              onClick={handleHomeClick}
              className="text-amber-400 hover:text-amber-300 transition-colors font-medium" 
              style={{ textShadow: '0 0 3px rgba(251, 191, 36, 0.3)' }} 
              data-testid="nav-home"
            >Home</button>
            <button 
              onClick={handleBooksClick}
              className="text-amber-400 hover:text-amber-300 transition-colors font-medium" 
              style={{ textShadow: '0 0 3px rgba(251, 191, 36, 0.3)' }} 
              data-testid="nav-books"
            >Books</button>
            <Link to="/coloring-pages" className="text-amber-400 hover:text-amber-300 transition-colors font-semibold" style={{ textShadow: '0 0 3px rgba(251, 191, 36, 0.3)' }} data-testid="nav-coloring">
              <span className="flex items-center gap-1">
                <Palette className="h-4 w-4 text-amber-400" />
                Coloring Pages
              </span>
            </Link>
            <button 
              onClick={handleAboutClick}
              className="text-amber-400 hover:text-amber-300 transition-colors font-medium" 
              style={{ textShadow: '0 0 3px rgba(251, 191, 36, 0.3)' }} 
              data-testid="nav-about"
            >About</button>
          </div>

          <div className="flex items-center gap-4">
            <button 
              onClick={() => setIsCartOpen(true)}
              className="relative p-2 text-amber-400 hover:text-amber-300 transition-colors"
              data-testid="cart-btn"
            >
              <ShoppingCart className="h-6 w-6" style={{ filter: 'drop-shadow(0 0 2px rgba(251, 191, 36, 0.5))' }} />
              {totalCartCount > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-amber-400 text-emerald-900 text-xs font-bold rounded-full flex items-center justify-center shadow-lg">
                  {totalCartCount}
                </span>
              )}
            </button>

            <button 
              className="md:hidden p-2 text-amber-400"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-emerald-800">
            <div className="flex flex-col gap-4">
              <button 
                className="text-amber-400 hover:text-amber-300 transition-colors font-medium text-left" 
                onClick={() => { setMobileMenuOpen(false); handleHomeClick(); }}
              >Home</button>
              <button 
                className="text-amber-400 hover:text-amber-300 transition-colors font-medium text-left" 
                onClick={() => { setMobileMenuOpen(false); handleBooksClick(); }}
              >Books</button>
              <Link to="/coloring-pages" className="text-amber-400 hover:text-amber-300 transition-colors font-semibold" onClick={() => setMobileMenuOpen(false)}>
                <span className="flex items-center gap-1">
                  <Palette className="h-4 w-4 text-amber-400" />
                  Coloring Pages
                </span>
              </Link>
              <button 
                className="text-amber-400 hover:text-amber-300 transition-colors font-medium text-left" 
                onClick={() => { setMobileMenuOpen(false); handleAboutClick(); }}
              >About</button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
